<template>
    <div class="content-box">
        <Title/>

        <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal">
            <el-menu-item
            :index="String(index + 1)"
            v-for="(i, index) of dataNav"
            :key="index"
            @click="handleSelect(index)">
            {{i.label}}</el-menu-item>
        </el-menu>

        <div class="mobile-select">
            <el-select
            v-model="name"
            @change="handleSelect2">
                <el-option
                v-for="item in dataNav"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </div>

        <Textlist/>
    </div>
</template>

<script>
export default {
    name: "exposure",
    data() {
        return {
            activeIndex: '1',
            name: '',
            dataNav: [],
            params: {
                json: 0,
            }
        }
    },
    created() {
        if(new Date().getMonth >= 2) {
            this.year = new Date().getFullYear()
        }else {
            this.year = new Date().getFullYear() - 1
            this.time = 'whole_year'
        }
        axios.get('http://www.315.100ec.cn/api/index.php?_a=product&f=most_company_list&type=' + this.$store.state.type + '&limit=20&year=' + this.year + '&time=' + this.time)
        .then((res) => {
            this.name = res.data.list[0].company
            for(var i of res.data.list.slice(0, 3)) {
                this.dataNav.push(
                    {
                        value: i.company,
                        label: i.company
                    }
                )
            }
            this.$store.commit('textparams', this.params)
            this.$store.commit('changeKeys', '电诉宝 ' + this.dataNav[0].value)
            this.$store.dispatch('getText')
        })
    },
    methods: {
        handleSelect(index) {
            this.$store.commit('changeKeys', '电诉宝 ' + this.dataNav[index].value)
            this.$store.dispatch('getText')
        },
        handleSelect2(value) {
            this.$store.commit('changeKeys', '电诉宝 ' + value)
            this.$store.dispatch('getText')
        },
    },
};
</script>